export const radius = {
  m: '4px',
  l: '8px',
  max: '50%',
};
